<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <ListsFilter :enable-filter-list="enableFilterList" />
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Lists Table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <ListTable
                    v-bind="$attrs"
                    :live="isLive"
                    :route="routes"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ListTable from './ListTable';
import ListsFilter from '../templates/ListsFilter';

export default {
    components: {
        ListTable,
        ListsFilter,
    },
    props: {
        isLive: Boolean,
    },
    data: function () {
        return {
            routes: {
                category: '/lists/categories/:id:/show',
                show: this.$route.path + '/:id:',
                edit: this.$route.path + '/:id:/edit',
                archive: '/lists/:id:/archive-vue',
                lookup: '/lists/:id:/lookup-vue',
                lookupRest: '/lists/:id:/reset-lookup-vue',
                export: '/lists/:id:/export',
            },
            enableFilterList: ['lists'],
        };
    },
};
</script>
